/**
 * Список хотспотов
 * @return Promise
 */
const hotspotList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/hotspot/getList",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Объект одного хотспота
 * data.id - обязательный параметр
 * @return Promise
 */
const hotspotGet = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/hotspot/get",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Редактирование хотспота
 */
const hotspotEdit = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/hotspot/edit",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Редактирование настроек сети
 */
const hotspotWifiEdit = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/hotspot/wifi/edit",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Заявка на новый хотспот
 */
const hotspotOrder = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/hotspot/order",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export { hotspotOrder, hotspotWifiEdit, hotspotEdit, hotspotGet, hotspotList };
